"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.view.title': '员工入职',
    'onboarding.view.meet': '认识',
    'onboarding.view.new_employee': '您的新AI员工',
    'onboarding.view.description.1': '通过',
    'onboarding.view.description.2': '创建和发布内容变得轻而易举。',
    'onboarding.view.description.3': '只需几分钟，',
    'onboarding.view.description.4': '就能创建内容策略和未来几个月的所有内容。',
    'onboarding.view.has_info': '拥有以下信息：',
    'onboarding.view.step': '步骤',
    'onboarding.view.step1_info': '姓名、年龄、性别、声音、照片',
    'onboarding.view.knowledge': '知识',
    'onboarding.view.learning_description': '将通过扫描您的网站、社交媒体和其他提供的信息来了解您公司的一切。',
    'onboarding.view.learning_description2': '',
    'onboarding.view.talk_with': '与聊天',
};
